import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ef-subscriptionPaths" }
const _hoisted_2 = { class: "ef-line" }
const _hoisted_3 = { class: "ef-line" }
const _hoisted_4 = { class: "ef-subscriptionPaths__search" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1)

import Header from '@/components/Header.vue';
import Table from '@/components/Table.vue';
import Input from '@/components/Input.vue';

import {computed, ComputedRef, onMounted, ref} from "vue";
import {TABLE_ITEMS} from "@/constants";
import {storeTraining} from '@/stores/training';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const _storeTraining = storeTraining();

//DATA
const searchTerm = ref('');
const trainingPaths = ref<Array<any>>([]);
const trainingPathsLength = ref(0);

const trainingPathsToDisplay: ComputedRef<Array<Object>> = computed(() => {
  if (trainingPaths.value.length === 0) {
    return [{ id: 1, bubble: 'test', fields: [{title: 'title', value: 'value'}, {title: 'title', value: 'value'}, {title: 'title', value: 'value'}], actions: [{ icon: 'fa-solid fa-pen', text: 'Editer', action: 'edit' }] }];
  } else {
    let result = trainingPaths.value;
    let actions = [
      { icon: 'fa-solid fa-eye', text: 'Voir', action: 'view' },
    ];
    if (searchTerm.value !== '') result = result.filter((folder: any) => folder.name.toLowerCase().includes(searchTerm.value.toLowerCase()));
    return result.map((item) => {
      const fields = [
        { title: 'Titre', value: item.title },
        { title: "Date de création", value: new Date(item.creationDate).toLocaleString()  },
        { title: 'Nombres de formation', value: item.trainings.length  }
      ]
      return { id: item.id, img: item.imgUrl ? item.imgUrl : 'empty', fields: fields, actions: actions };
    });
  }
});

const loading = ref(true);
onMounted(() => {
  _storeTraining.getAllTrainingPaths(0,TABLE_ITEMS*2).then((response) => {
    trainingPaths.value = response;
    trainingPathsLength.value = response.length;
    loading.value = false;
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Header, {
        icone: "fa-solid fa-user-graduate",
        title: "Parcours de formation"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(Input, {
          type: "text",
          placeholder: "Rechercher un parcours ...",
          modelValue: searchTerm.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createVNode(Table, {
      items: _unref(trainingPathsToDisplay),
      numberItems: 0,
      loading: loading.value,
      onView: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push(`/trainingPaths/${$event}`)))
    }, null, 8, ["items", "loading"])
  ]))
}
}

})